export default __webpack_public_path__ + "static/media/Whitney_9781408308202.1af1f802.jpg";